import ChallengeSticker from './ChallengeSticker';

export default ChallengeSticker;
